/* eslint-disable */
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { GridView, ViewList, Map } from '@mui/icons-material'

export function ViewModeSelector({ currentView, onViewChange, showMap = false }) {
  return (
    <ToggleButtonGroup
      value={currentView}
      exclusive
      onChange={(_, newView) => newView && onViewChange(newView)}
      size="small"
      sx={{
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        '& .MuiToggleButton-root': {
          border: 'none',
          textTransform: 'none',
          fontWeight: 500,
          gap: 0.5,
          '&.Mui-selected': {
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            '&:hover': {
              bgcolor: 'primary.dark',
            },
          },
        },
      }}
    >
      <ToggleButton value="grid">
        <GridView fontSize="small" />
        Grid
      </ToggleButton>
      <ToggleButton value="list">
        <ViewList fontSize="small" />
        List
      </ToggleButton>
      {showMap && (
        <ToggleButton value="map">
          <Map fontSize="small" />
          Map
        </ToggleButton>
      )}
    </ToggleButtonGroup>
  )
}